import _regeneratorRuntime from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { EventEmitter } from 'events';

var debug = require('debug')('CRATE:Event');

export var Event =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Event, _EventEmitter);

  function Event(opts) {
    var _this;

    _classCallCheck(this, Event);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Event).call(this));
    _this._buffer = [];
    _this._document = opts.document;
    _this._communicationChannel = _this._document._communication._data_comm;
    _this._name = opts.EventName;

    _this._document.on(_this.getType(), function (msg) {
      if (msg && msg.pairs) {
        _this.receiveBuffer(msg);
      } else if (msg) {
        _this.receiveBuffer({
          pairs: [msg]
        });
      } else {
        console.error('Receive Event without data', _this.getType());
      }
    });

    _this._document.on("".concat(_this._name, "_Action_Event"), function (msg) {
      debug("on \"".concat(_this._name, "_Action_Event\""));

      _this.action(msg);
    });

    return _this;
  }

  _createClass(Event, [{
    key: "getEncapsulatedMessage",
    value: function getEncapsulatedMessage(msg) {}
  }, {
    key: "setLastChangesTime",
    value: function setLastChangesTime() {
      this._document.setLastChangesTime();
    }
  }, {
    key: "getType",
    value: function getType() {
      if (this._name) {
        return "".concat(this._name, "_Event");
      } else {
        console.error('Event without name');
      }
    }
  }, {
    key: "getPacket",
    value: function getPacket(message) {
      return _objectSpread({
        event: this.getType()
      }, message);
    }
  }, {
    key: "broadcast",
    value: function broadcast(message) {
      var _this2 = this;

      var causal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      clearTimeout(this._timeoutBuffer);

      this._buffer.push(_objectSpread({}, message, {
        causalId: this.getCausalId()
      }));

      this._timeoutBuffer = setTimeout(function () {
        var msg = _this2.getPacket({
          pairs: _this2._buffer
        });

        _this2.broadcastStream(_objectSpread({}, msg, {
          stream: causal
        }));

        debug('broadcast message', msg);
        _this2._buffer = [];
      }, 1);
    }
  }, {
    key: "getCausalId",
    value: function getCausalId() {
      var causalId = this._communicationChannel.broadcast._causality.increment();

      return causalId;
    }
  }, {
    key: "broadcastStream",
    value: function broadcastStream(msg) {
      var stream = this._communicationChannel.streamBroadcast();

      this.sendStream(stream, msg);
    }
  }, {
    key: "unicast",
    value: function () {
      var _unicast = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id, message) {
        var causal,
            causalId,
            msg,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                causal = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                causalId = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;

                if (!causalId) {
                  causalId = this.getCausalId();
                }

                msg = this.getPacket({
                  pairs: [_objectSpread({}, message, {
                    causalId: causalId
                  })]
                });
                id = this.formatId(id);
                _context.next = 7;
                return this.unicastStream(id, _objectSpread({}, msg, {
                  stream: causal
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function unicast(_x, _x2) {
        return _unicast.apply(this, arguments);
      };
    }()
  }, {
    key: "formatId",
    value: function formatId(id) {
      debug('Id before formatiting', id);
      var cleanId = this.cleanId(id);
      cleanId = cleanId + '-I';
      debug('Id after formatiting', cleanId);
      return cleanId;
    }
  }, {
    key: "cleanId",
    value: function cleanId(id) {
      var fixedPart = id.slice(0, id.length - 4);
      var varPart = id.slice(id.length - 4, id.length);
      varPart = this.removeFromString('-I', varPart);
      varPart = this.removeFromString('-O', varPart);
      return fixedPart + varPart;
    }
  }, {
    key: "removeFromString",
    value: function removeFromString(StringtoBeremove, s) {
      var indexOfLast = s.lastIndexOf(StringtoBeremove);

      if (indexOfLast >= 0) {
        s = s.slice(0, indexOfLast) + s.slice(indexOfLast + StringtoBeremove.length);
      }

      return s;
    }
  }, {
    key: "unicastStream",
    value: function () {
      var _unicastStream = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(id, msg) {
        var stream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                debug('message sent on stream unicast');
                stream = this._communicationChannel.streamUnicast(id);
                _context2.next = 4;
                return this.sendStream(stream, msg);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function unicastStream(_x3, _x4) {
        return _unicastStream.apply(this, arguments);
      };
    }()
  }, {
    key: "sendStream",
    value: function sendStream(stream, msg) {
      var _this3 = this;

      var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      new Promise(function (resolve, reject) {
        var msgString = '';

        try {
          msgString = JSON.stringify(msg);
        } catch (e) {
          console.error('Error in JSON.stringify of object', e);
          reject('Error in JSON.stringify of object');
        }

        var chunks = _this3.chunkSubstr(msgString, maxSize);

        var info = {
          numberOfChunks: chunks.length
        };
        stream.write(info);
        chunks.forEach(function (chunk) {
          stream.write(chunk);
        });
        stream.end();
        resolve();
      });
    }
  }, {
    key: "sendLocalBroadcast",
    value: function sendLocalBroadcast(msg) {
      var _this4 = this;

      //msg=this.setBatchCounter({pairs:[msg]})
      this._communicationChannel.broadcast._source.getNeighbours().forEach(function (neighbourId) {
        return _this4.unicast(neighbourId, msg, false, _this4.getCausalId());
      });
    }
  }, {
    key: "receiveBuffer",
    value: function receiveBuffer(_ref) {
      var _this5 = this;

      var pairs = _ref.pairs,
          stream = _ref.stream,
          originID = _ref.originID;
      debug('receiveBuffer', this.getType(), pairs.length, pairs); // remove the first element since it has passed by _receive

      if (pairs.length >= 1) {
        pairs.forEach(function (elem) {
          if (stream) {
            _this5.passMsgByBroadcast(elem, originID);
          } else {
            _this5.receive(elem);
          }
        });
      } else {
        console.warn('Receiving empty message');
      }
    }
  }, {
    key: "passMsgByBroadcast",
    value: function passMsgByBroadcast(elem, originID) {
      var causalId = elem.pair && elem.pair.causalId || elem.causalId;
      debug('passMsgByBroadcast:', {
        elem: elem,
        originID: originID,
        causalId: causalId
      }); // stream false to avoid to have a loop in the case of a stream

      var packet = this.getPacket({
        pairs: [elem],
        stream: false
      });
      var isReady = elem.isReady;
      var broadcast = this._communicationChannel.broadcast;
      var message = this.getBroadcastMessageFormat(broadcast._protocol, causalId, isReady, packet);

      if (!(message.id && message.id.e)) {
        throw new Error("Message without Id");
      }

      broadcast._receive(causalId + '-O', message);
    }
  }, {
    key: "sendBroadcast",
    value: function sendBroadcast(msg) {
      var isReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      debug('Send Broadcast ', {
        msg: msg,
        isReady: isReady
      });
      this._document.lastSentMsgId = this._communicationChannel.broadcast.send(_objectSpread({}, msg, {
        isReady: isReady
      }), null, isReady, false);
      return this._document.lastSentMsgId;
    }
  }, {
    key: "sendUnicast",
    value: function sendUnicast(id, msg) {
      this._communicationChannel.sendUnicast(id, msg);
    }
  }, {
    key: "haveBeenReceived",
    value: function haveBeenReceived(element) {
      return this._communicationChannel.broadcast._shouldStopPropagation(element);
    }
  }, {
    key: "getSize",
    value: function getSize(msg) {
      var string = JSON.stringify(msg);
      return string.length;
    }
  }, {
    key: "receive",
    value: function receive(msg) {
      debug('default receive', msg);
    }
  }, {
    key: "action",
    value: function action(msg) {
      console.error('action not defined', this._name);
    }
  }, {
    key: "sendAction",
    value: function sendAction(name, args) {
      debug('sendAction', args);
      this.Event("".concat(name, "_Action"), args);
    }
  }, {
    key: "Event",
    value: function Event(name, args) {
      debug('Event: ', "".concat(name, "_Event"), args);

      this._document.emit("".concat(name, "_Event"), args);
    }
  }, {
    key: "chunkSubstr",
    value: function chunkSubstr(str, size) {
      try {
        var numChunks = Math.ceil(str.length / size);
        var chunks = new Array(numChunks);

        for (var i = 0, o = 0; i < numChunks; ++i, o += size) {
          chunks[i] = str.substr(o, size);
        }

        return chunks;
      } catch (e) {
        console.error('Error in spliting the object ', e);
        throw new Error('Error in spliting the object ', e);
      }
    }
  }, {
    key: "getCausalID",
    value: function getCausalID(lseqNode) {
      var causalId = {
        e: lseqNode.t.s,
        c: lseqNode.t.c
      };
      debug('getCausalID', {
        lseqNode: lseqNode,
        causalId: causalId
      });
      return causalId;
    }
  }, {
    key: "getBroadcastMessageFormat",
    value: function getBroadcastMessageFormat(protocol, id, isReady, payload) {
      return {
        protocol: protocol,
        id: id,
        isReady: isReady,
        payload: payload
      };
    }
  }, {
    key: "close",
    value: function close() {}
  }]);

  return Event;
}(EventEmitter);